export const BADGE_TYPE = {
    filled: 'filled',
    outline: 'outline',
}
